/**
 * Footer newsletter feedback.
 *
 * The submit is deliberately left alone. The store has Shopify's spam
 * protection switched on for customer forms, and Shopify injects the CAPTCHA
 * token during its own native submit flow — anything that intercepts that
 * flow (fetch, a retargeted POST) arrives without the token and Shopify
 * answers `400 Missing CAPTCHA token`, so the signup is silently lost. The
 * native POST is therefore the only submission path that works here.
 *
 * What is left to fix is what the native POST does to the page: it reloads
 * and drops the visitor at the top, far above the footer, so a successful
 * signup looks like nothing happened. This module paints the wait before the
 * navigation, then on the way back restores the visitor to the field they
 * used and states the outcome there.
 */

const FORM_SELECTOR = 'form.gbk-footer__form';

/** Shopify appends this to the URL it redirects an accepted signup back to. */
const SUCCESS_FLAG = 'customer_posted';

const showOutcome = (block, message, state, text) => {
  message.textContent = text;
  message.dataset.state = state;

  /*
    `instant` rather than `smooth`: this runs on load, and animating the
    document from the top on arrival reads as the page being yanked. Landing
    already in position reads as never having left.
  */
  block.scrollIntoView({ block: 'center', behavior: 'instant' });
  message.focus({ preventScroll: true });
};

const form = document.querySelector(FORM_SELECTOR);
const block = form?.closest('.gbk-footer__newsletter');
const message = form?.querySelector('.gbk-footer__message');
const button = form?.querySelector('.gbk-footer__submit');

if (form && block && message && button) {
  form.addEventListener('submit', () => {
    /*
      No preventDefault: the native submission has to proceed for the CAPTCHA
      token to be attached. This only marks the button as busy for the moment
      before the navigation replaces the page.
    */
    form.dataset.state = 'loading';
    button.setAttribute('aria-disabled', 'true');
  });

  /*
    Liquid has already written the message when Shopify re-renders with
    `form.errors`. A success is not as dependable — the redirect does not
    always leave `form.posted_successfully?` set on the document it lands on —
    so the URL flag is what a success is read from, and the text comes from
    the node's own `data-success`.
  */
  if (message.dataset.state === 'error') {
    showOutcome(block, message, 'error', message.textContent.trim());
  } else if (new URLSearchParams(window.location.search).get(SUCCESS_FLAG) === 'true') {
    showOutcome(block, message, 'success', message.dataset.success || 'Thanks for subscribing!');
  }
}
